// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button ion-icon {
  font-size: 13px;
}

.profile ion-icon {
  margin-right: 4px;
}

.ml-2 {
  margin-left: 15px;
}

ion-item {
  --min-height: 35px !important;
}

ion-avatar ion-icon {
  font-size: 40px !important;
  color: #b9b6b6;
}

ion-item ion-label {
  font-size: 12px;
  color: #494657;
  font-weight: 600;
}

ion-badge {
  font-size: 12px;
}

ion-item ion-label {
  margin: 4px 0px;
}

h2 {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
}

ion-item img {
  width: 75px;
  padding: 13px;
  border-radius: 50%;
}

.signout {
  cursor: pointer;
  color: #c72727 !important;
}

ion-list {
  padding-top: 0px;
  padding-bottom: 0px;
}

.creditDiv {
  --background: #e0e0e0;
}

.profileDiv {
  --background: #6030ff;
  --padding-start: 0px !important;
}

ion-label p {
  color: #eaeaea !important;
  text-align: left;
  font-size: 10px !important;
}

.whatsapp {
  color: #2dd55b;
  font-size: 20px;
  padding-right: 5px;
}

.rcs {
  color: #6030ff;
  font-size: 20px;
  padding-right: 5px;
}

.sms {
  color: #0054e9;
  font-size: 20px;
  padding-right: 5px;
}

.call {
  color: #0054e9;
  font-size: 20px;
  padding-right: 5px;
}

.creditBody ion-label {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/profile/profile.component.scss","webpack://./../../omnichannel%20frontend%20before%20nikhils%20api%20added/omnichannel/src/app/profile/profile.component.scss"],"names":[],"mappings":"AAAA;EACQ,eAAA;ACCR;;ADGA;EACI,iBAAA;ACAJ;;ADIA;EACI,iBAAA;ACDJ;;ADIA;EACI,6BAAA;ACDJ;;ADIA;EACI,0BAAA;EACA,cAAA;ACDJ;;ADIA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;ACDJ;;ADIA;EACI,eAAA;ACDJ;;ADIA;EACI,eAAA;ACDJ;;ADIA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACI,gBAAA;ACDR;;ADIA;EACI,WAAA;EACA,aAAA;EACA,kBAAA;ACDJ;;ADUA;EACI,eAAA;EACA,yBAAA;ACPJ;;ADYA;EACI,gBAAA;EACA,mBAAA;ACTJ;;ADYA;EACI,qBAAA;ACTJ;;ADYA;EACI,qBAAA;EACA,+BAAA;ACTJ;;ADYA;EACI,yBAAA;EACA,gBAAA;EACA,0BAAA;ACTJ;;ADYA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;ACTJ;;ADYA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;ACTJ;;ADYA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;ACTJ;;ADYA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;ACTJ;;ADYA;EACI,aAAA;EACA,mBAAA;ACTJ","sourcesContent":["ion-button ion-icon {\r\n        font-size: 13px;\r\n    \r\n}\r\n\r\n.profile ion-icon {\r\n    margin-right: 4px;\r\n}\r\n\r\n\r\n.ml-2 {\r\n    margin-left: 15px;\r\n}\r\n\r\nion-item {\r\n    --min-height: 35px !important;\r\n}\r\n\r\nion-avatar ion-icon {\r\n    font-size: 40px !important;\r\n    color: #b9b6b6;\r\n}\r\n\r\nion-item ion-label {\r\n    font-size: 12px;\r\n    color: #494657;\r\n    font-weight: 600;\r\n}\r\n\r\nion-badge {\r\n    font-size: 12px;\r\n}\r\n\r\nion-item ion-label {\r\n    margin: 4px 0px;\r\n}\r\n\r\nh2 {\r\n    color: #fff;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n        text-align: left;\r\n}\r\n\r\nion-item img {\r\n    width: 75px;\r\n    padding: 13px;\r\n    border-radius: 50%;\r\n}\r\n\r\n// .profileIcon {\r\n//     width: 100%;\r\n//     margin: 0 auto;\r\n//     text-align: center;\r\n// }\r\n\r\n.signout {\r\n    cursor: pointer;\r\n    color: #c72727 !important;\r\n\r\n}\r\n\r\n\r\nion-list {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n}\r\n\r\n.creditDiv {\r\n    --background: #e0e0e0;\r\n}\r\n\r\n.profileDiv {\r\n    --background: #6030ff;\r\n    --padding-start: 0px !important;\r\n}\r\n\r\nion-label p {\r\n    color: #eaeaea !important;\r\n    text-align: left;\r\n    font-size: 10px !important;\r\n}\r\n\r\n.whatsapp {\r\n    color: #2dd55b;\r\n    font-size: 20px;\r\n    padding-right: 5px;\r\n}\r\n\r\n.rcs {\r\n    color: #6030ff;\r\n    font-size: 20px;\r\n    padding-right: 5px;\r\n}\r\n\r\n.sms {\r\n    color: #0054e9;\r\n    font-size: 20px;\r\n    padding-right: 5px;\r\n}\r\n\r\n.call {\r\n    color: #0054e9;\r\n    font-size: 20px;\r\n    padding-right: 5px;\r\n}\r\n\r\n.creditBody ion-label {\r\n    display: flex;\r\n    align-items: center;\r\n}","ion-button ion-icon {\n  font-size: 13px;\n}\n\n.profile ion-icon {\n  margin-right: 4px;\n}\n\n.ml-2 {\n  margin-left: 15px;\n}\n\nion-item {\n  --min-height: 35px !important;\n}\n\nion-avatar ion-icon {\n  font-size: 40px !important;\n  color: #b9b6b6;\n}\n\nion-item ion-label {\n  font-size: 12px;\n  color: #494657;\n  font-weight: 600;\n}\n\nion-badge {\n  font-size: 12px;\n}\n\nion-item ion-label {\n  margin: 4px 0px;\n}\n\nh2 {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  text-align: left;\n}\n\nion-item img {\n  width: 75px;\n  padding: 13px;\n  border-radius: 50%;\n}\n\n.signout {\n  cursor: pointer;\n  color: #c72727 !important;\n}\n\nion-list {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n\n.creditDiv {\n  --background: #e0e0e0;\n}\n\n.profileDiv {\n  --background: #6030ff;\n  --padding-start: 0px !important;\n}\n\nion-label p {\n  color: #eaeaea !important;\n  text-align: left;\n  font-size: 10px !important;\n}\n\n.whatsapp {\n  color: #2dd55b;\n  font-size: 20px;\n  padding-right: 5px;\n}\n\n.rcs {\n  color: #6030ff;\n  font-size: 20px;\n  padding-right: 5px;\n}\n\n.sms {\n  color: #0054e9;\n  font-size: 20px;\n  padding-right: 5px;\n}\n\n.call {\n  color: #0054e9;\n  font-size: 20px;\n  padding-right: 5px;\n}\n\n.creditBody ion-label {\n  display: flex;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
